module.exports = __webpack_public_path__ + "static/img/discount_flag_v2.ff571ef.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/discount_flag_v2.png
// module id = 81
// module chunks = 1